import(/* webpackMode: "eager", webpackExports: ["KilkayaMeta"] */ "/vercel/path0/apps/web/src/app/[locale]/(fullscreen)/watch/[assetId]/KilkayaMeta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoObjectSchemaInjector"] */ "/vercel/path0/apps/web/src/components/seo/VideoObjectSchemaInjector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/apps/web/src/components/ui/buttons/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlaylistCard"] */ "/vercel/path0/apps/web/src/features/playlist/components/cards/PlaylistCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlaylistController"] */ "/vercel/path0/apps/web/src/features/playlist/components/PlaylistController.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayback"] */ "/vercel/path0/apps/web/src/features/video-playback/components/VideoPlayback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlaybackErrorDisplay"] */ "/vercel/path0/apps/web/src/features/video-playback/components/VideoPlaybackErrorDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/features/authentication/hooks/useAccessToAsset.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/features/authentication/hooks/useActiveSubscriptions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useAuthentication"] */ "/vercel/path0/packages/features/authentication/hooks/useAuthentication.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticationContext","AuthenticationProvider"] */ "/vercel/path0/packages/features/authentication/provider/index.tsx");
